import React from "react";
export const aLink = React.forwardRef(({
  href,
  children,
  replace: _replace,
  shallow: _shallow,
  prefetch: _prefetch,
  ...rest
}, ref) => {
  const hrefAsString = typeof href === "string" ? href : (_href$pathname => {
    const pathname = (_href$pathname = href.pathname) !== null && _href$pathname !== void 0 ? _href$pathname : "/";
    const params = new URLSearchParams();
    if (href.query) {
      for (const [key, value] of Object.entries(href.query)) {
        if (value === undefined || value === null) {
          continue;
        }
        if (Array.isArray(value)) {
          for (const item of value) {
            params.append(key, String(item));
          }
        } else {
          params.append(key, String(value));
        }
      }
    }
    const query = params.toString();
    const hash = href.hash ? href.hash.startsWith("#") ? href.hash : `#${href.hash}` : "";
    return `${pathname}${query ? `?${query}` : ""}${hash}`;
  })();
  return /*#__PURE__*/React.createElement("a", {
    ref: ref,
    href: hrefAsString,
    ...rest
  }, children);
});
export const noHrefLink = React.forwardRef(({
  className,
  "aria-current": ariaCurrent,
  "aria-label": ariaLabel,
  onClick,
  children
}, ref) => /*#__PURE__*/React.createElement("a", {
  ref: ref,
  className: className,
  "aria-current": ariaCurrent,
  "aria-label": ariaLabel,
  onClick: onClick
}, children));
export const SparkleContext = React.createContext({
  components: {
    link: aLink
  }
});
//# sourceMappingURL=context.js.map